
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Web3CheckIcon extends Vue {}
